import { TseAccountType } from './tse_account_type.js';

export function name(accountType: TseAccountType): string {
  switch (accountType) {
    case TseAccountType.StoredValue:
      return 'Stored Value';
    case TseAccountType.MealPlan:
      return 'Meal Plan';
    case TseAccountType.CashEquivalency:
      return 'Cash Equivalency';
  }
}
